import { endOfDay, format, startOfDay, startOfMonth, subDays, subMonths, subYears } from 'date-fns'

export const PERIODS = ['day', 'week', 'month', 'year', 'custom'] as const
export type Period = (typeof PERIODS)[number]

/** Подписи переключателя — как в ТЗ (п. 3). */
export const PERIOD_LABELS: Record<Period, string> = {
  day: 'За день',
  week: 'За неделю',
  month: 'За месяц',
  year: 'За год',
  custom: 'За период',
}

/** «за неделю», «за месяц» — для подписей вида «Посетителей за неделю». */
export const PERIOD_GENITIVE: Record<Period, string> = {
  day: 'за день',
  week: 'за неделю',
  month: 'за месяц',
  year: 'за год',
  custom: 'за период',
}

export interface DateRange {
  from: Date
  to: Date
}

export function getPeriodRange(
  period: Period,
  now: Date = new Date(),
  custom?: DateRange,
): DateRange {
  const to = endOfDay(now)
  switch (period) {
    case 'day':
      return { from: startOfDay(now), to }
    case 'week':
      // ТЗ п. 3.1: недельный диапазон до текущей даты, например 30.10 – 06.11.
      return { from: startOfDay(subDays(now, 7)), to }
    case 'month':
      return { from: startOfDay(subMonths(now, 1)), to }
    case 'year':
      return { from: startOfDay(subYears(now, 1)), to }
    case 'custom':
      return custom ?? { from: startOfMonth(now), to }
  }
}

export const formatRange = (range: DateRange): string =>
  `${format(range.from, 'dd.MM.yyyy')} – ${format(range.to, 'dd.MM.yyyy')}`

export const toInputDate = (date: Date): string => format(date, 'yyyy-MM-dd')
